import FullscreenModal from '@/Components/Common/FullscreenModal.jsx';
import {Box, Link as MuiLink, Typography} from '@mui/material';
import * as React from 'react';

const TermsAndConditionsModal = () => {
    return (
        <FullscreenModal title="Conditions d'utilisation">
            <Box sx={{mb: 4}}>
                <Typography align="center" variant="" component="h3">
                    Mitsubishi Electric Europe B.V. – Succursale France{' '}
                </Typography>
                <Typography align="center" variant="" component="h3">
                    Mitsubishi Electric Europe B.V. – Succursale France Division Chauffage et Climatisation
                </Typography>
            </Box>
            <Typography variant="h2" textAlign="center">
                Conditions Générales d'Utilisation du « Logiciel SelectME 2.0 »
            </Typography>
            <Typography sx={{mb: 8}}>
                <span className="text-bold">MITSUBISHI ELECTRIC EUROPE B.V.</span>, société de droit néerlandais, prise
                en sa succursale française dont l'établissement principal est situé 2, rue de l’Union, 92565
                Rueil-Malmaison Cedex, immatriculée au R.C.S. de Nanterre sous le numéro 405 247 230 (ci-après dénommé{' '}
                <span className="text-bold">« MITSUBISHI ELECTRIC »</span>), propose une solution en ligne{' '}
                <span className="text-bold">« SelectME 2.0 »</span> (ci-après le{' '}
                <span className="text-bold">« Logiciel »</span>) pour la sélection des produits de climatisation et
                chauffage de marque MITSUBISHI ELECTRIC destinés à l'installateur ou distributeur de produits de
                climatisation et chauffage dénommé ci-après <span className="text-bold">« l'Utilisateur »</span>. Merci
                de lire attentivement ces conditions avant d’utiliser le Logiciel « SelectME 2.0 » de MITSUBISHI
                ELECTRIC. En utilisant le Logiciel « SelectME 2.0 » de MITUSIBHSI ELECTRIC, vous acceptez expressément
                d’être soumis aux présentions Conditions Générales d’Utilisation.
            </Typography>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Article 1 : Objet
                </Typography>
                <Typography>
                    Les présentes Conditions Générales d'Utilisation (ci-après{' '}
                    <span className="text-bold">« CGU »</span>) ont pour objet de définir les modalités et conditions
                    dans lesquelles MITSUBISHI ELECTRIC met à disposition de l’Utilisateur le Logiciel en ligne
                    accessible via [URL du site]. L’accès et l’utilisation du Logiciel sont soumis au respect des
                    présentes CGU.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Article 2 : Licence d'utilisation
                </Typography>
                <Typography>
                    Il est concédé à l'Utilisateur une licence non exclusive d'Utilisation du Logiciel selon les termes
                    prévus aux présentes Conditions d'Utilisation (ci-après la{' '}
                    <span className="text-bold">« Licence »</span>). La mise à disposition du Logiciel ne constitue ni
                    une vente ni une location. Ce Logiciel demeure en toutes circonstances la propriété de Mitsubishi
                    Electric. La Licence est incessible et est concédée à titre gratuit.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Article 3 : Acceptation et modification des conditions d'utilisation
                </Typography>
                <Typography>
                    Toute utilisation du Logiciel implique nécessairement et automatiquement l'acceptation par
                    l'Utilisateur des Conditions d'Utilisation ainsi que des éventuelles modifications ultérieures sans
                    aucune autre formalité. Les Conditions d'Utilisation peuvent être modifiées à tout moment par
                    Mitsubishi Electric, et ce sans préavis.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Article 4 : Droits de propriété intellectuelle
                </Typography>
                <Typography>
                    Le Logiciel est protégé par le Code de la propriété intellectuelle, les dispositions des traités
                    internationaux ainsi que toutes les législations applicables sur le droit d'auteur. Tous les droits
                    de propriété intellectuelle relatifs au Logiciel (notamment et de manière non limitative, ceux
                    afférents à toute image, photographie, animation, vidéo, son, musique, texte et mini application
                    intégrés au Logiciel), à la documentation imprimée qui éventuellement l'accompagne et à toute copie
                    de sauvegarde du Logiciel, sont détenus par Mitsubishi Electric. En conséquence, est interdite toute
                    copie du manuel ou des documentations techniques associées au Logiciel. Tous les droits non
                    expressément concédés au titre de la présente licence sont réservés par Mitsubishi Electric. La
                    violation de l'un des droits de l'auteur du Logiciel est un délit de contrefaçon sanctionné en
                    France par l'article 335-2-1 du Code de la Propriété Intellectuelle et puni de 3 ans
                    d'emprisonnement et de 300 000 € d'amende.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Article 5 : Engagements de l'Utilisateur
                </Typography>
                <Typography>
                    L'Utilisateur s'engage à respecter les Conditions d'Utilisation. L'Utilisateur prend toutes les
                    mesures nécessaires pour que ses employés, agents, ayants droit ou autres personnes sous sa
                    direction ou son contrôle et qui ont accès au Logiciel ou à la documentation qui l'accompagne,
                    respectent les modalités du présent contrat de licence. L'Utilisateur s'engage à ne jamais modifier
                    ou tenter de modifier, copier, traduire, adapter, arranger, reproduire, séparer, désassembler ou
                    décompiler de quelque manière que ce soit le Logiciel mis à sa disposition. L'Utilisateur s'engage
                    également à ne pas tenter de quelque manière que ce soit de découvrir le code source du Logiciel.
                    L'Utilisateur s'engage à ne pas enlever ou tenter d'enlever les mentions de copyright pouvant
                    apparaître sur le Logiciel. Le Logiciel ne peut être ni prêté, ni loué, ni vendu, ni commercialisé,
                    ni mis à disposition, ni utilisé au profit de tiers, sous quelque forme que ce soit, à titre gratuit
                    ou onéreux. L'Utilisateur garantit MITSUBISHI ELECTRIC contre toute utilisation illicite, non
                    conforme et/ou non autorisée des informations accessibles sur SelectME par lui-même ou un tiers.
                    L'Utilisateur garantit MITSUBISHI ELECTRIC contre toute action qui serait engagée à son encontre ou
                    toute plainte qui serait déposée contre elle, y compris par un tiers, du fait de l'utilisation du
                    Logiciel dans des conditions qui ne seraient pas conformes aux présentes Conditions d'Utilisation.
                    Cette garantie couvre toute somme que Mitsubishi Electric serait tenue de verser à quelque titre que
                    ce soit, y compris les honoraires d'avocat et frais de justice.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Article 6 : Accès au Logiciel et gestion des identifiants
                </Typography>
                <Typography>
                    Pour accéder au Logiciel, l'Utilisateur se voit attribuer un identifiant et un mot de passe
                    (ci-après les <span className="text-bold">« Identifiants »</span>) par MITSUBISHI ELECTRIC. Ces
                    Identifiants sont personnels et confidentiels. L'Utilisateur est responsable de leur conservation et
                    s'engage à ne pas les communiquer à des tiers. MITSUBISHI ELECTRIC se réserve le droit de modifier
                    ou de désactiver les Identifiants si elle estime que les conditions d'utilisation ne sont pas
                    respectées, ou pour des raisons de sécurité. En cas de perte ou de vol des Identifiants,
                    l'Utilisateur est tenu d'en informer immédiatement MITUSBISHI ELECTRIC, qui prendra les mesures
                    nécessaires pour rétablir l'accès au Logiciel dans les meilleurs délais.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Article 7 : Suspension ou suppression de compte
                </Typography>
                <Typography>
                    MITSUBISHI ELECTRIC se réserve le droit de suspendre ou de supprimer l’accès de l’Utilisateur au
                    Logiciel en cas de manquement aux présentes CGU§, ou pour toute autre raison justifiée, notamment en
                    cas de violation de la loi ou de tentative d’atteinte à la sécurité du système. MITSUBISHI ELECTRIC
                    informera l’Utilisateur des raisons de la suspension ou suppression, sauf en cas d’urgence ou de
                    nécessité impérieuse.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Article 8 : Exclusion de garantie
                </Typography>
                <Typography>
                    L'utilisation du Logiciel n'est assortie d'aucune garantie quelle qu'elle soit. MITSUBISHI ELECTRIC
                    n'accorde aucune garantie expresse ou implicite, quant à l'utilisation du Logiciel par
                    l'Utilisateur. MITSUBISHI ELECTRIC n'est en aucun cas obligée de dispenser une maintenance et/ou des
                    mises à jour additionnelles à l'Utilisateur. MITSUBISHI ELECTRIC ne saurait être tenue pour
                    responsable de toute inexécution, par l'Utilisateur, de ses obligations notamment des consignes
                    d'utilisation et de fonctionnement. MITSUBISHI ELECTRIC ne garantit pas que le Logiciel fonctionnera
                    correctement dans n'importe quel environnement informatique ou que son fonctionnement sera
                    infaillible. MITSUBISHI ELECTRIC exclut toute responsabilité pour tous les dommages, directs ou
                    indirects, liés à l'utilisation ou à la performance du Logiciel, notamment pour pertes de bénéfices,
                    manques à gagner, pertes ou altérations de données, pertes de clientèle, trouble commercial
                    quelconque résultant de l'utilisation ou de l'incapacité d'utilisation du Logiciel, du mauvais
                    fonctionnement ou de la défaillance du Logiciel, et ce, quelle qu'en soit la cause. MITSUBISHI
                    ELECTRIC ne pourra en particulier être tenue responsable des dégradations éventuelles des
                    informations, des programmes, des fichiers ou des bases de données consécutives à l'utilisation du
                    Logiciel.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Article 9 : Rapport obtenu par l’utilisation du Logiciel
                </Typography>
                <Typography>
                    Le rapport est obtenu en utilisant le Logiciel fourni par MITSUBISHI ELECTRIC et les données
                    d’entrée de l’étude réalisée par l’Utilisateur. La simulation est basée sur un modèle de calcul
                    simplifié, les données présentes dans le rapport (par exemple : calculs d’économie d’énergie) sont
                    fournies à titre purement indicatif et ne peuvent en aucun cas remplacer un bilan thermique réalisé
                    par un bureau d’étude. MITSUBISHI ELECTRIC ne peut être tenu pour responsable en cas de mauvaise
                    sélection du matériel par l’Utilisateur du Logiciel.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Article 10 : Données personnelles
                </Typography>
                <Typography>
                    Les Parties s’engagent réciproquement à prendre toutes les mesures nécessaires pour rendre le
                    traitement et le contrôle des données personnelles conformes au droit applicable en matière de
                    protection des données personnelles à savoir au Règlement Général européen 2016/679 (RGPD), à la loi
                    du 20 juin 2018 et à l’ordonnance du 12 décembre 2018. Chaque Partie, en tant que responsable de
                    traitement, a l’obligation d’informer les personnes concernées au regard du traitement de leurs
                    données à caractère personnel. Cependant, les Parties reconnaissent qu’elles ne disposent pas d’un
                    lien direct avec le personnel de l’autre Partie. Elles s’engagent à ce titre à porter à l’attention
                    de leur personnel la politique de gestion des données personnelles de l’autre Partie.
                </Typography>

                <Typography>La politique de MITSUBISHI ELECTRIC est accessible sous : </Typography>
                <MuiLink href="http://emea.mitsubishielectric.com/fr/utilities/privacy/index.page">
                    http://emea.mitsubishielectric.com/fr/utilities/privacy/index.page
                </MuiLink>

                <Typography>
                    En cas de non-respect par l’une des parties de ses engagements au présent article, celle-ci
                    indemnisera intégralement l’autre partie de tout préjudice subi en découlant, et notamment des frais
                    de justice et d’avocats engagés de ce fait.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Article 11 : Indépendance des Parties
                </Typography>
                <Typography>
                    Le recours au Logiciel de MITSUBISHI ELECTRIC n’implique aucune obligation pour les Parties de
                    conclure un accord de collaboration ou tout autre contrat. L’Utilisateur reconnaît être un
                    Professionnel qualifié indépendant et disposer de toutes les habilitations professionnelles requises
                    par la loi ou les règlements pour exercer son activité.
                </Typography>
            </Box>
            <Box sx={{mb: 4}}>
                <Typography variant="" component="h3">
                    Article 12 : Loi applicable et juridiction compétente
                </Typography>
                <Typography>
                    Le présent contrat est régi par le droit français. Si une disposition du contrat devait être tenue
                    pour non valide ou déclarée telle en application d'une loi, d'un règlement ou à la suite d'une
                    décision définitive d'une juridiction compétente, les autres dispositions garderont toute leur force
                    et leur portée. Tout différend relatif à la validité, à l'interprétation, à l'exécution ou à la
                    résiliation du présent contrat sera soumis à la compétence exclusive du Tribunal de Commerce de
                    Nanterre.
                </Typography>
            </Box>
        </FullscreenModal>
    );
};

export default TermsAndConditionsModal;
